import { getUrlTrackingParams } from './functions';
import { hasStorageAvailable } from './storage';


export const saveItemToSessionStorage = (key: string, value: string) => {
  if (!key || !value) return false;

  if (hasStorageAvailable('sessionStorage')) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }
};

/**
 * @description Retrieves an item from sessionStorage
 * @param {string} key - The key of the item to retrieve
 * @returns {string} parsed value of the item or empty string if the item is not found
 */
export const getItemFromSessionStorage = (key: string) => {
  if (hasStorageAvailable('sessionStorage')) {
    const value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : '';
  }
  return '';
};

/**
 * @description Returns an object with lead_source and lead_source_detail properties
 * @returns {object} Object containing lead_source and lead_source_detail
 */
const getLeadSourceObject = () => {
  return {
    lead_source: '',
    lead_source_detail: '',
  };
};

/**
 * @description Reads lead source properties from sessionStorage
 * @returns {object} Object containing lead_source and lead_source_detail
 */
export const readLeadSourcePropertiesFromSessionStorage = () => {
  const leadSourceObject = getLeadSourceObject();

  try {
    leadSourceObject.lead_source = getItemFromSessionStorage('lead_source');
    leadSourceObject.lead_source_detail = getItemFromSessionStorage('lead_source_detail');
  } catch {
    return leadSourceObject;
  }

  return leadSourceObject;
};

export const handleLeadSource = () => {
  const { lead_source, lead_source_detail } = getUrlTrackingParams();

  if (lead_source) {
    saveItemToSessionStorage('lead_source', lead_source);
  }

  if (lead_source_detail) {
    saveItemToSessionStorage('lead_source_detail', lead_source_detail);
  }
};
